import { notification } from "antd";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "shared/components/Header";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { StoreContext } from "shared/store";
import graphql from "utils/api/graphql";
import { NOTIFICATION_TYPES } from "utils/constants";
import View from "./View";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.NOTIFICATION);
  const LIST = t("LIST", { returnObjects: true });
  const { user } = useContext(StoreContext);
  const [pagination, setPagination] = useState({});
  const [activeFilter, setActiveFilter] = useState("all");

  const buildFilter = (filterKey) => {
    const base = {};
    if (filterKey === "tasks") {
      base.where = { type: NOTIFICATION_TYPES.TASK_REMINDER };
    } else if (filterKey === "calls") {
      base.where = { type: NOTIFICATION_TYPES.MISSED_CALL };
    }
    return base;
  };

  const filter = { ...buildFilter(activeFilter), ...pagination };

  const [markAllAsRead] = useMutation(graphql.mutations.UPDATE_NOTIFICATIONS, {
    refetchQueries: [
      "Notifications",
      { query: graphql.queries.UNREAD_NOTIFICATIONS_COUNT },
    ],
    awaitRefetchQueries: true,
    onCompleted: () => {
      notification.success({
        message: LIST.ALL_MARKED_READ,
        closeIcon: null,
      });
    },
  });

  const handleMarkAllAsRead = () => {
    markAllAsRead({
      variables: {
        where: { recipients: { id: user?.id } },
        data: { isReadBy: [{ id: user?.id }] },
      },
    });
  };

  return (
    <>
      <Header
        title={LIST.TITLE}
        actions={[
          {
            text: LIST.MARK_ALL_READ,
            onClick: handleMarkAllAsRead,
          },
        ]}
      />
      <View
        filter={filter}
        setValues={setPagination}
        skip={pagination.skip || 0}
        activeFilter={activeFilter}
        setActiveFilter={(key) => {
          setActiveFilter(key);
          setPagination({});
        }}
        userId={user?.id}
      />
    </>
  );
};

export default List;
